import { tt } from '@agos/shared'

/**
 * The code a customer shows the waiter to spend points at the table - `FRONTEND.md` §9.806, BACKEND.md §10A.452,
 * owner O153: *"how can customer apply «vernostné body» on reštaurácia. We dont have QR code readers"*.
 *
 * Six digits from `POST /customer-auth/me/table-code`, valid ten minutes, once. What this file holds is how they are
 * shown and how long they have left, so the card can be tested without a clock of its own.
 */

/** `482 913` - two groups of three, the way a waiter reads them back. */
export function groupedCode(code: string): string {
  return code.length === 6 ? `${code.slice(0, 3)} ${code.slice(3)}` : code
}

/** Whole seconds until the code stops working, never below nought; nought for a time that cannot be read. */
export function secondsLeft(expiresAt: string, now: Date): number {
  const end = Date.parse(expiresAt)
  if (Number.isNaN(end)) return 0
  return Math.max(0, Math.floor((end - now.getTime()) / 1000))
}

/** `Platí ešte 9:58`, or that it has run out. */
export function leftNote(seconds: number): string {
  if (seconds <= 0) return tt('Kód vypršal - vytvorte nový.')
  const minutes = Math.floor(seconds / 60)
  const rest = String(seconds % 60).padStart(2, '0')
  return `${tt('Platí ešte')} ${minutes}:${rest}`
}
